import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "input-container" }
const _hoisted_2 = {
  key: 0,
  class: "col md:col-12"
}
const _hoisted_3 = { class: "add-tag-group list-manage-link" }
const _hoisted_4 = { class: "subtitle" }
const _hoisted_5 = { class: "tag-data grid" }
const _hoisted_6 = { class: "col md:col-6 tag-select-div" }
const _hoisted_7 = { class: "col md:col-6 tag-select-div" }
const _hoisted_8 = { class: "col md:col-6" }
const _hoisted_9 = { class: "add-tag-group list-manage-link" }
const _hoisted_10 = { class: "col md:col-6" }
const _hoisted_11 = { class: "add-tag-group list-manage-link" }
const _hoisted_12 = { class: "buttons-container" }
const _hoisted_13 = { class: "tag-buttons" }
const _hoisted_14 = { class: "subtitle" }
const _hoisted_15 = { class: "tag-data grid" }
const _hoisted_16 = { class: "col col-12" }
const _hoisted_17 = { class: "buttons-container" }
const _hoisted_18 = { class: "tag-buttons" }
const _hoisted_19 = { class: "subtitle" }
const _hoisted_20 = { class: "tag-data grid" }
const _hoisted_21 = { class: "col col-12" }
const _hoisted_22 = { class: "col col-12" }
const _hoisted_23 = { class: "buttons-container" }
const _hoisted_24 = { class: "tag-buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MultiSelect = _resolveComponent("MultiSelect")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_TranslatedText = _resolveComponent("TranslatedText")!
  const _component_EditBox = _resolveComponent("EditBox")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_FormInput = _resolveComponent("FormInput")!
  const _component_Select = _resolveComponent("Select")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_MultiSelect, {
        value: _ctx.selectedTags,
        error: '',
        onChange: _ctx.handleTagChange,
        label: "tags.manage.select.tags",
        name: "tags",
        id: "tags",
        items: _ctx.tagSelectOptions,
        placeholder: _ctx.getValueForString('tags.select.placeholder'),
        groupValues: "tags",
        groupLabel: "tagGroup"
      }, null, 8, ["value", "onChange", "items", "placeholder"])
    ]),
    (_ctx.userHasPermission('tags:manage:*') && _ctx.editable)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("p", _hoisted_3, [
            _createElementVNode("a", {
              href: "#",
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.showManageModal = true), ["prevent"]))
            }, [
              _createVNode(_component_font_awesome_icon, { icon: "plus" }),
              _cache[12] || (_cache[12] = _createTextVNode("  ", -1)),
              _createVNode(_component_TranslatedText, { path: "tags.manage.action" })
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.userHasPermission('tags:manage:*'))
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 1,
          modelValue: _ctx.showManageModal,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.showManageModal) = $event)),
          title: "tags.manage.heading",
          showFooter: true,
          onCancel: _ctx.handleModalHide
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("p", null, [
                _createVNode(_component_TranslatedText, { path: "tags.manage.description" })
              ]),
              _cache[13] || (_cache[13] = _createElementVNode("hr", null, null, -1))
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_EditBox, {
                  tabindex: "0",
                  value: _ctx.selectedGroup,
                  items: _ctx.getTagGroupOptions,
                  label: "tags.manage.tag.groups",
                  onEdit: _ctx.handleEditGroup,
                  onChange: _ctx.handleTagGroupManageChange,
                  onMoveUp: _ctx.handleTagGroupMoveUp,
                  onMoveDown: _ctx.handleTagGroupMoveDown
                }, null, 8, ["value", "items", "onEdit", "onChange", "onMoveUp", "onMoveDown"])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_EditBox, {
                  tabindex: "0",
                  value: _ctx.selectedTag,
                  items: _ctx.getTagOptions,
                  label: "tags.manage.tag.tags",
                  onEdit: _ctx.handleEditTag,
                  onChange: _ctx.handleTagManageChange,
                  onMoveUp: _ctx.handleTagMoveUp,
                  onMoveDown: _ctx.handleTagMoveDown
                }, null, 8, ["value", "items", "onEdit", "onChange", "onMoveUp", "onMoveDown"])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("p", _hoisted_9, [
                  (_ctx.userHasPermission('tags:manage:groups'))
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: "#",
                        onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => {
                _ctx.showManageModal = false;
                _ctx.showManageGroupModal = true;
              }, ["prevent"]))
                      }, [
                        _createVNode(_component_font_awesome_icon, { icon: "plus" }),
                        _cache[14] || (_cache[14] = _createTextVNode("  ", -1)),
                        _createVNode(_component_TranslatedText, { path: "tags.manage.add.group" })
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("p", _hoisted_11, [
                  (_ctx.userHasPermission('tags:manage:tags'))
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: "#",
                        onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => {
                _ctx.showManageModal = false;
                _ctx.showManageTagModal = true;
              }, ["prevent"]))
                      }, [
                        _createVNode(_component_font_awesome_icon, { icon: "plus" }),
                        _cache[15] || (_cache[15] = _createTextVNode("  ", -1)),
                        _createVNode(_component_TranslatedText, { path: "tags.manage.add.tag" })
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ]),
          footer: _withCtx(() => [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_Button, {
                  text: "common.close",
                  size: "sm",
                  variant: "secondary",
                  onClick: _ctx.handleModalHide
                }, null, 8, ["onClick"])
              ])
            ])
          ]),
          _: 1
        }, 8, ["modelValue", "onCancel"]))
      : _createCommentVNode("", true),
    (_ctx.userHasPermission('tags:manage:groups'))
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 2,
          modelValue: _ctx.showManageGroupModal,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.showManageGroupModal) = $event)),
          title: "tags.manage.heading.group",
          showFooter: true,
          onCancel: _ctx.handleGroupModalHide
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("p", null, [
                _createVNode(_component_TranslatedText, { path: "tags.manage.description" })
              ]),
              _cache[16] || (_cache[16] = _createElementVNode("hr", null, null, -1))
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createVNode(_component_FormInput, {
                  id: "edit_action_title_input",
                  name: "editTitle",
                  label: "form.name",
                  type: "text",
                  required: "",
                  value: _ctx.newGroupName,
                  onChange: _ctx.updateNewGroupName
                }, null, 8, ["value", "onChange"])
              ])
            ])
          ]),
          footer: _withCtx(() => [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createVNode(_component_Button, {
                  text: 
              _ctx.editMode
                ? 'tags.manage.action.group.update'
                : 'tags.manage.action.group.create'
            ,
                  size: "sm",
                  disabled: false,
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.editMode ? _ctx.handleEditGroupSubmit() : _ctx.handleAddTagGroup()))
                }, null, 8, ["text"]),
                _createVNode(_component_Button, {
                  text: "common.back",
                  size: "sm",
                  variant: "secondary",
                  onClick: _ctx.handleGroupModalHide
                }, null, 8, ["onClick"]),
                (_ctx.editMode)
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 0,
                      text: "common.delete",
                      size: "sm",
                      variant: "error",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showDeleteGroupModal = true))
                    }))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _: 1
        }, 8, ["modelValue", "onCancel"]))
      : _createCommentVNode("", true),
    (_ctx.userHasPermission('tags:manage:tags'))
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 3,
          modelValue: _ctx.showManageTagModal,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.showManageTagModal) = $event)),
          title: "tags.manage.heading.tag",
          showFooter: true,
          onCancel: _ctx.handleTagModalHide
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("p", null, [
                _createVNode(_component_TranslatedText, { path: "tags.manage.description.tag" })
              ]),
              _cache[17] || (_cache[17] = _createElementVNode("hr", null, null, -1))
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createVNode(_component_Select, {
                  value: _ctx.editMode ? _ctx.getSelectedGroup.value : _ctx.newTagGroup,
                  items: _ctx.getTagGroupOptions,
                  onChange: _ctx.updateNewTagGroup,
                  label: "tags.manage.tag.groups",
                  name: "newTagNameGroup",
                  id: "newTagNameGroup",
                  disabled: _ctx.editMode
                }, null, 8, ["value", "items", "onChange", "disabled"])
              ]),
              _createElementVNode("div", _hoisted_22, [
                _createVNode(_component_FormInput, {
                  id: "newTagName",
                  name: "newTagName",
                  label: "form.name",
                  type: "text",
                  required: "",
                  value: _ctx.newTagName,
                  onChange: _ctx.updateNewTagName
                }, null, 8, ["value", "onChange"])
              ])
            ])
          ]),
          footer: _withCtx(() => [
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _createVNode(_component_Button, {
                  text: 
              _ctx.editMode
                ? 'tags.manage.action.tag.update'
                : 'tags.manage.action.tag.create'
            ,
                  size: "sm",
                  disabled: false,
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.editMode ? _ctx.handleEditTagSubmit() : _ctx.handleAddTag()))
                }, null, 8, ["text"]),
                _createVNode(_component_Button, {
                  text: "common.back",
                  size: "sm",
                  variant: "secondary",
                  onClick: _ctx.handleTagModalHide
                }, null, 8, ["onClick"]),
                (_ctx.editMode)
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 0,
                      text: "common.delete",
                      size: "sm",
                      variant: "error",
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.showDeleteTagModal = true))
                    }))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _: 1
        }, 8, ["modelValue", "onCancel"]))
      : _createCommentVNode("", true),
    _createVNode(_component_Modal, {
      modelValue: _ctx.showDeleteGroupModal,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.showDeleteGroupModal) = $event)),
      title: "tags.manage.action.group.delete",
      onConfirm: _ctx.handleDeleteGroup,
      onCancel: _ctx.handleDeleteModalHide,
      onDismiss: _ctx.handleDeleteModalHide
    }, {
      default: _withCtx(() => [
        _createElementVNode("p", null, [
          _createVNode(_component_TranslatedText, { path: "tags.manage.description.delete.group" })
        ])
      ]),
      footer: _withCtx(({ confirm, cancel }) => [
        _createVNode(_component_Button, {
          text: "common.cancel",
          onClick: cancel,
          size: "sm",
          outline: ""
        }, null, 8, ["onClick"]),
        _createVNode(_component_Button, {
          text: "common.delete",
          variant: "error",
          size: "sm",
          onClick: confirm
        }, null, 8, ["onClick"])
      ]),
      _: 1
    }, 8, ["modelValue", "onConfirm", "onCancel", "onDismiss"]),
    _createVNode(_component_Modal, {
      modelValue: _ctx.showDeleteTagModal,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.showDeleteTagModal) = $event)),
      title: "tags.manage.action.tag.delete",
      onConfirm: _ctx.handleDeleteTag,
      onCancel: _ctx.handleDeleteModalHide,
      onDismiss: _ctx.handleDeleteModalHide
    }, {
      default: _withCtx(() => [
        _createElementVNode("p", null, [
          _createVNode(_component_TranslatedText, { path: "tags.manage.description.delete.tag" })
        ])
      ]),
      footer: _withCtx(({ confirm, cancel }) => [
        _createVNode(_component_Button, {
          text: "common.cancel",
          onClick: cancel,
          size: "sm",
          outline: ""
        }, null, 8, ["onClick"]),
        _createVNode(_component_Button, {
          text: "common.delete",
          variant: "error",
          size: "sm",
          onClick: confirm
        }, null, 8, ["onClick"])
      ]),
      _: 1
    }, 8, ["modelValue", "onConfirm", "onCancel", "onDismiss"])
  ], 64))
}